import { createSelector } from 'reselect';

import { Selector } from 'react-redux';
import { CommonState } from './commonTypes';
import { Breadcrumbs } from '../model/commonModel';
import { RootState } from '../../core/redux/model/rootStateModel';

const getRoot = (state: RootState) => state.common;

export const breadcrumbs = createSelector<[Selector<RootState, CommonState>], Breadcrumbs[]>(
  getRoot,
  (root: CommonState) => root.breadcrumbs,
);

export const activeMenuItem = createSelector<[Selector<RootState, CommonState>], number | undefined>(
  getRoot,
  (root: CommonState) => root.activeMenuItem,
);

export const phrase = createSelector<[Selector<RootState, CommonState>], string>(
  getRoot,
  (root: CommonState) => root.phrase,
);
